export default __webpack_public_path__ + "static/media/Aasa.92e34480.png";